export const CaseMockData = [
  {
    dateProcessed: "24 Jul 2020 13:10",
    caseID: "MORR:004086200001496",
    executionNo: 1,
    status: 2,
    result: 1,
    failures: 1,
  },
  {
    dateProcessed: "24 Jul 2020 13:10",
    caseID: "MORR:006658700057003",
    executionNo: 1,
    status: 2,
    result: 1,
    failures: 1,
  },
  {
    dateProcessed: "24 Jul 2020 13:10",
    caseID: "MORR:000640300053376",
    executionNo: 1,
    status: 2,
    result: 1,
    failures: 1,
  },
  {
    dateProcessed: "24 Jul 2020 13:10",
    caseID: "MORR:004086200001422",
    executionNo: 1,
    status: 2,
    result: 1,
    failures: 1,
  },
  {
    dateProcessed: "24 Jul 2020 13:10",
    caseID: "MORR:009341800029707",
    executionNo: 1,
    status: 1,
    result: 3,
    failures: 1,
  },
  {
    dateProcessed: "24 Jul 2020 13:10",
    caseID: "MORR:001677500052890",
    executionNo: 1,
    status: 1,
    result: 3,
    failures: 1,
  },
  {
    dateProcessed: "24 Jul 2020 13:10",
    caseID: "MORR:005846000070348",
    executionNo: 1,
    status: 2,
    result: 2,
    failures: 1,
  },
  {
    dateProcessed: "24 Jul 2020 13:10",
    caseID: "MORR:002944300008891",
    executionNo: 1,
    status: 2,
    result: 2,
    failures: 1,
  },
  {
    dateProcessed: "24 Jul 2020 13:10",
    caseID: "MORR:002623000022101",
    executionNo: 1,
    status: 1,
    result: 3,
    failures: 1,
  },
  {
    dateProcessed: "24 Jul 2020 13:10",
    caseID: "MORR:008257300080678",
    executionNo: 1,
    status: 1,
    result: 3,
    failures: 1,
  },
  {
    dateProcessed: "24 Jul 2020 13:10",
    caseID: "MORR:008158900078515",
    executionNo: 1,
    status: 1,
    result: 3,
    failures: 1,
  },
  {
    dateProcessed: "24 Jul 2020 13:10",
    caseID: "MORR:002897400022389",
    executionNo: 1,
    status: 1,
    result: 3,
    failures: 1,
  },
  {
    dateProcessed: "24 Jul 2020 13:10",
    caseID: "MORR:000159200095340",
    executionNo: 1,
    status: 1,
    result: 3,
    failures: 1,
  },
  {
    dateProcessed: "24 Jul 2020 13:10",
    caseID: "MORR:008840600060017",
    executionNo: 1,
    status: 1,
    result: 3,
    failures: 1,
  },
  {
    dateProcessed: "24 Jul 2020 13:10",
    caseID: "MORR:003728500010009",
    executionNo: 1,
    status: 1,
    result: 3,
    failures: 1,
  },
  {
    dateProcessed: "24 Jul 2020 13:10",
    caseID: "MORR:005426200098792",
    executionNo: 1,
    status: 1,
    result: 3,
    failures: 1,
  },
];
